import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Permission } from './permission.model';
import { URL_BASE } from '../../core/constants';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../../shared/http-utils';

@Injectable()
export class PermissionService {

  private PERMISSIONS_URI = 'permissions';

  constructor(private http: HttpClient) {
  }

  public getAll(): Observable<Array<Permission>> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.PERMISSIONS_URI}`;

    return this.http.get<Permission[]>(url, { headers })
  }

  public getById(id: string): Observable<Permission> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/${this.PERMISSIONS_URI}/${id}`;

    return this.http.get<Permission>(url, { headers });
  }

}
